<div class="debt-list-container">
    <h1>Debts Overview</h1>
    <div *ngIf="loading == true">
        <h2>Loading data...</h2>
    </div>
    <div *ngIf="loading == false" fxLayout="column wrap">
        <div>
            <h3>Debts ({{debts.length}})</h3>
        </div>
        <div *ngIf="debts.length == 0">
            <h2>No debt records found!</h2>
        </div>
        <div *ngIf="debts.length > 0" fxLayout="row wrap">
            <div *ngFor="let debt of debts">
                <mat-card class="debt-card">
                    <mat-card-header>
                        <mat-card-title>{{debt.principalBorrowed | currency}}</mat-card-title>
                        <mat-card-subtitle>{{debt.name}}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content fxLayout="row">
                        <div class="debt-card-data-item">
                            <div>{{debt.durationMonths | amDuration:'months'}}</div>
                            <div><small>Term</small></div>
                        </div>
                        <div class="debt-card-data-item">
                            <div>{{debt.principalPayoutAt | date : 'mediumDate'}}</div>
                            <div><small>Paid Out At</small></div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button type="button" mat-button color="primary" [routerLink]="['../debts', debt.id]">
                            <mat-icon>folder_open</mat-icon>Open
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
        <div>
            <h3>Exploration ({{exploratoryDebts.length}})</h3>
        </div>
        <div *ngIf="exploratoryDebts.length == 0">
            <h2>No exploratory debt records found!</h2>
        </div>
        <div *ngIf="exploratoryDebts.length > 0" fxLayout="row wrap">
            <div *ngFor="let exploratoryDebt of exploratoryDebts">
                <mat-card class="debt-card">
                    <mat-card-header>
                        <mat-card-title>{{exploratoryDebt.principalBorrowed | currency}}</mat-card-title>
                        <mat-card-subtitle>{{exploratoryDebt.name}}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content fxLayout="row">
                        <div class="debt-card-data-item">
                            <div>{{exploratoryDebt.durationMonths | amDuration:'months'}}</div>
                            <div><small>Term</small></div>
                        </div>
                        <div class="debt-card-data-item">
                            <div>{{exploratoryDebt.principalPayoutAt | date : 'mediumDate'}}</div>
                            <div><small>Paid Out At</small></div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button type="button" mat-button color="primary" [routerLink]="['../debts', exploratoryDebt.id]">
                            <mat-icon>folder_open</mat-icon>Open
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
        <button mat-fab color="primary" aria-label="Add new debt" class="debt-fab--absolute" [routerLink]="['./create']">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>